
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
export interface ICheckoutDeliveryOptionsRadioButtonProps {
    isChecked: boolean;
    value?: string;
    ariaSetSize: number;
    ariaPosInSet: number;
    ariaLabel?: string;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

/**
 *
 * AddPaymentForm SFC
 * @extends {React.FC<ICheckoutDeliveryOptionsRadioButtonProps>}
 */
const CheckoutDeliveryOptionsRadioButton: React.FC<ICheckoutDeliveryOptionsRadioButtonProps> = ({
    isChecked,
    value,
    ariaSetSize,
    ariaPosInSet,
    ariaLabel,
    onChange
}) => {
    if (!value) {
        return null;
    }

    return (
        <input
            className='ms-checkout-delivery-options__input-radio'
            checked={isChecked}
            aria-checked={isChecked}
            type='radio'
            value={value}
            name='deliveryOptions'
            onChange={onChange}
        />
    );
};

export default CheckoutDeliveryOptionsRadioButton;
